import { render, staticRenderFns } from "./addBtnDrawers.vue?vue&type=template&id=3e4e1b0a&scoped=true&"
import script from "./addBtnDrawers.vue?vue&type=script&lang=js&"
export * from "./addBtnDrawers.vue?vue&type=script&lang=js&"
import style0 from "./addBtnDrawers.vue?vue&type=style&index=0&id=3e4e1b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e1b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VHover,VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle})
